import Box from "@mui/material/Box";
import { useContext } from "react";
import { styled } from "@mui/material/styles";
import { UserContext } from "components/context/UserProvider";
import SmallRingLogo from "components/ui/icons/SmallRingLogo.svg";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

const StyledUser = styled("div")(({ theme }) => ({
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.fontSize,
}));

const StyledSmallRingLogo = styled(Box)({
  marginRight: 10,
  width: 45,
  height: 45,
});

const BrandAndUser = () => {
  const { user } = useContext(UserContext);

  return (
    <Link to="/" width={1}>
      <Button sx={{ width: 1, height: 1 }} style={{ textTransform: "none" }}>
        <StyledSmallRingLogo>
          <img src={SmallRingLogo} />
        </StyledSmallRingLogo>
        <StyledUser>
          {user.first_name} {user.last_name}
        </StyledUser>
      </Button>
    </Link>
  );
};

export default BrandAndUser;
